/* eslint-disable */
import React, { Component, useState, useContext, useEffect, useCallback } from 'react';
import { AuthContext } from '../AuthContext';
import axios from 'axios';
import { Dropdown } from '@fluentui/react';
import '@boldreports/javascript-reporting-controls/Scripts/bold.report-viewer.min';
import '@boldreports/javascript-reporting-controls/Content/material/bold.reports.all.min.css';
//Data-Visualization
import '@boldreports/javascript-reporting-controls/Scripts/data-visualization/ej.bulletgraph.min';
import '@boldreports/javascript-reporting-controls/Scripts/data-visualization/ej.chart.min';
//Reports react base
import '@boldreports/react-reporting-components/Scripts/bold.reports.react.min';

const rootUrl = window.location.protocol + '//' + window.location.host + '/';
const reportServiceUrl = rootUrl + "reportviewer";

export const ReportViewer = () => {
    const authContext = useContext(AuthContext);
    const [selectedReport, setSelectedReport] = useState();
    const [reports, setReports] = useState([]);
    const [viewerHeight, setViewerHeight] = useState("500px");
    const [heightSet, setHeightSet] = useState(false);
    const [reportVisible, setReportVisible] = useState(false);

    useEffect(() => {
        var height = window.innerHeight - 206;
        var reportHeight = "" + height + "px";
        setViewerHeight(reportHeight);
        setHeightSet(true);
    }, [])

    useEffect(() => {
        if (authContext.isAuthenticated && authContext.isReportReader) {
            axios.get(rootUrl + "report", { headers: { "Authorization": "Bearer " + authContext.accessToken } }).then((res) => {
                setReports(res.data.map((item) => {
                    return { key: item.id, text: item.name, data: item };
                }));
            });
        }
    }, [authContext])
    const reportSelected = useCallback((event, item) => {
        setSelectedReport(item);
        setReportVisible(false);
        setTimeout(() => setReportVisible(true), 300);
    });
    const renderOption = useCallback((option) => {
        return (<div>
            <div style={{fontWeight: "bold"}}>{option.data.name}</div>
            <div>{option.data.description}</div>
        </div>);
    })
    return (
        <div>
            <Dropdown options={reports}
                selectedKey={selectedReport ? selectedReport.id : undefined}
                placeholder="Select a report to view."
                onRenderOption={renderOption}
                onChange={reportSelected} />

            <div style={{ height: viewerHeight }}>
                {(selectedReport != null && heightSet && reportVisible) &&
                    <BoldReportViewerComponent id="reportViewer"
                        reportServiceUrl={reportServiceUrl}
                        reportPath={selectedReport ? selectedReport.data.id : undefined}
                        isResponsive={true}
                        autoRender={true}>

                    </BoldReportViewerComponent>

                }
            </div>
        </div>
    );
}
